<template>
  <div>
    <div
      v-if="isBrand"
      class="row m-0 mb-3"
    >
      <div class="col-lg-6 pl-0 col-sm-12 pr-sm-0 pr-lg-1">
        <div class="my-retailer-banner-1 my-retailer-banner">
          <div class="banner-content">
            <div class="title">
              Your Direct Retailers
            </div>
            <div class="sub-title">
              Access your exclusive partners in this tab
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6 pr-0 col-sm-12 pl-sm-0 pl-lg-1 mt-sm-1 mt-lg-0">
        <div class="my-retailer-banner-2 my-retailer-banner">
          <div class="banner-content">
            <div class="title">
              Invite your existing retailers
            </div>
            <div class="sub-title">
              to join the platform for free
            </div>
            <div class="mt-10-px">
              <b-button
                v-b-modal.add_a_user
                variant="custom-primary"
                class="d-flex align-items-center"
              >
                <featherIcon
                  icon="PlusIcon"
                  size="18"
                />
                <span class="ml-5-px"> Add a Retailer </span>
              </b-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex browse-nav-bar">
      <div
        class="browse-nav-item"
        :class="{ 'active': CONNECTION_TABS.DIRECT === selectedTab }"
        @click="onLoadTab(CONNECTION_TABS.DIRECT)"
      >
        DIRECT
      </div>
      <div
        class="browse-nav-item"
        :class="{ 'active': CONNECTION_TABS.MARKETPLACE === selectedTab }"
        @click="onLoadTab(CONNECTION_TABS.MARKETPLACE)"
      >
        MARKETPLACE
      </div>
    </div>
    <div class="row mb-1">
      <div
        v-if="tableLength"
        class="position-relative col-md-4"
      >
        <b-form-input
          v-model="search"
          :placeholder="getTextForPlaceholder"
          class="search-product"
        />
        <feather-icon
          icon="SearchIcon"
          size="18"
          class="wallet-search-icon"
        />
      </div>
      <div
        v-if="(isEntityAdmin || isSalesManager) && isBrand && !loading && tableLength && selectedTab === CONNECTION_TABS.DIRECT"
        class="col-lg-3 col-md-4 pl-md-0 mt-sm-1 mt-md-0"
      >
        <reps-list-dropdown
          :options="salesReps"
          :show-self-option="true"
          @on-select-options="onFilterBySalesRep"
        />
      </div>
      <div
        v-if="isEntityAdmin && isBrand && !loading && tableLength && selectedTab === CONNECTION_TABS.DIRECT"
        class="col-lg-3 col-md-4 pl-md-0 mt-sm-1 mt-md-0"
      >
        <reps-list-dropdown
          :options="salesManagers"
          placeholder="Sales manager"
          :show-self-option="true"
          @on-select-options="onFilterBySalesManager"
        />
      </div>
      <div
        v-if="isShowImportExport"
        :class="hasDirectUsers ? 'col-lg-2 col-md-12 mt-sm-1 mt-lg-0': 'col-lg-12 col-md-12'"
        class="d-flex flex-row justify-content-end"
      >
        <b-button
          v-b-modal.import_direct_retailers
          variant="outline-secondary-black"
        >
          <import-icon class="mr-5-px" />
          Import
        </b-button>
      </div>

    </div>
    <div
      v-if="!loading && !(tableItems && tableItems.length)"
      class="items-empty-message-container"
    >
      <div class="mb-1">
        <send-icon />
      </div>
      <b-card-text class="list-empty-text-color">
        There are no connections yet.
      </b-card-text>
    </div>
    <b-card
      v-else
      class="app-connection-request-list"
    >
      <div
        v-if="loading"
        class="text-center p-5"
      >
        <b-spinner />
      </div>
      <div
        v-else
        class="mb-2"
      >
        <b-table
          :fields="tableFields"
          :items="tableItems"
          class="connection-table"
          show-empty
          :current-page="currentPage"
          :per-page="perPage"
          :filter="search"
          :filter-included-fields="filterIncludedFields"
          responsive
          empty-text="No data found."
        >
          <!-- Column: SR Name -->
          <template #cell(salesRepName)="data">
            <span class="d-block text-nowrap">
              {{ data.item.isCreatedBySelf ? profile.entityName : data.item.salesRepName }}
            </span>
          </template>

          <template #cell(firstOrderDate)="data">
            <div
              v-if="data.item.firstOrderDate"
              class="d-flex flex-nowrap"
            >
              <feather-icon
                icon="ClockIcon"
                size="18"
                class="mr-50 text-info"
              />
              {{ data.item.firstOrderDate }}
            </div>
          </template>
          <template #cell(nickName)="data">
            <add-nick-name
              :data="data"
              @load-connections="getData()"
            />
          </template>
          <template #cell(lastOrderDate)="data">
            <div
              v-if="data.item.lastOrderDate"
              class="d-flex flex-nowrap"
            >
              <feather-icon
                icon="ClockIcon"
                size="18"
                class="mr-50 text-info"
              />
              {{ data.item.lastOrderDate }}
            </div>
          </template>
          <template #cell(socialLinks)="data">
            <div class="d-flex flex-nowrap mt-2">
              <b-link
                v-if="data.item.socialLinks.instagramLink"
                class="mr-2"
                :href="data.item.socialLinks.instagramLink || '#'"
                target="_blank"
              >
                <instagram-icon />
              </b-link>
              <b-link
                v-if="data.item.socialLinks.facebookLink"
                class="mr-2"
                :href="data.item.socialLinks.facebookLink || '#'"
                target="_blank"
              >
                <facebook-icon />
              </b-link>
              <b-link
                v-if="data.item.socialLinks.linkedinLink"
                class="mr-2"
                :href="data.item.socialLinks.linkedinLink || '#'"
                target="_blank"
              >
                <linked-in-icon />
              </b-link>
              <b-link
                v-if="data.item.socialLinks.twitterLink"
                class="mr-2"
                :href="data.item.socialLinks.twitterLink || '#'"
                target="_blank"
              >
                <twitter-icon />
              </b-link>
              <b-link
                v-if="data.item.socialLinks.websiteLink"
                class="mr-2"
                :href="data.item.socialLinks.websiteLink || '#'"
                target="_blank"
              >
                <feather-icon
                  icon="GlobeIcon"
                  size="20"
                />
              </b-link>
            </div>
          </template>
          <template #head(actions)>
            <div class="elements-center">
              actions
            </div>
          </template>
          <template #head(firstName)>
            {{ getRoleText }} Name
          </template>
          <template #head(entityName)>
            {{ isBrand ? 'Store Name' : 'Brand' }}
          </template>
          <template #cell(teammates)="data">
            <span
              class="cursor-pointer d-flex align-items-center text-primary"
              @click="openTeammatesModal(data.item)"
            >
              <feather-icon
                icon="UsersIcon"
                size="16"
                class="mr-50"
              />
              <span class="text-nowrap">View</span>
            </span>
          </template>
          <template #cell(actions)="data">
            <div class="elements-center">
              <span
                class="cursor-pointer"
                @click="editUser(data.item)"
              >
                <pencil-icon-2 />
              </span>
            </div>
          </template>
          <template #cell(discount)="data">
            {{ getDicountWithPercent(data.item.discount) }}%
          </template>
          <template #cell(paymentTerms)="data">
            <div class="payment-term-block">
              {{ data.item.paymentTerms }}
            </div>
          </template>
        </b-table>
        <b-modal
          id="connection-request"
          ref="connnectionRequest"
          class="custom-modal"
          size="lg"
          hide-footer
          hide-header
          hide-header-close
          no-close-on-backdrop
          centered
        >
          <connection-request
            :brand-id="brandId"
            :retailer-id="retailerId"
            :request-id="requestId"
            :status="status"
            :request-message="requestMessage"
            @close-modal="closeModal"
            @update-request="getData"
          />
        </b-modal>
      </div>
      <div class="mx-2 mb-2 mt-auto">
        <b-row>
          <b-col
            cols="12"
            class="d-flex align-items-center justify-content-center"
          >
            <b-pagination
              v-model="currentPage"
              :per-page="perPage"
              :total-rows="tableDataCount"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>
    <add-user-modal @load-connections="getData()" />
    <edit-user-modal
      v-if="modalReloadKey"
      :key="'edit_user_modal'+modalReloadKey"
      :user-details="userData"
      :load-connections="getData"
    />

    <b-modal
      id="import_direct_retailers"
      size="lg"
      modal-class="modal-primary custom-model"
      centered
      hide-header-close
      hide-header
      hide-footer
    >
      <div>
        <div class="pb-50 border-bottom">
          <span class="custom-modal-heading">Import direct retailers</span>
          <feather-icon
            class="float-right close-x-icon"
            icon="XIcon"
            size="24"
            @click="closeImportDirectRetailersModal"
          />
        </div>
        <div class="my-1">
          <span>Export direct retailers</span>
          <b-button
            variant="primary"
            class="ml-1"
            :disabled="isExporting"
            @click="exportDirectUsers"
          >
            <div class="d-flex align-items-center">
              <feather-icon
                icon="DownloadIcon"
                class="mr-1"
                size="20"
              />
              {{ isExporting ? 'Downloading' : 'Download' }}
            </div>
          </b-button>
        </div>
        <label
          v-if="!directRetailersImportFile"
          for="uploadCatalog"
          class="fileDownload elements-center"
        >
          <feather-icon
            icon="UploadCloudIcon"
            size="50"
            color="skyblue"
          />
          <h4 class="font-weight-bolder"><b>Drag & Drop</b></h4>
          <h6>or click to select files from your system</h6>
        </label>
        <div
          v-if="directRetailersImportFile"
          class="d-flex file-droped mt-50"
        >
          <b-img
            :src="xlsxIcon"
            class="mx-1"
            alt="ErrorIcon"
          />
          <span class="catalog-label name">Name: {{ directRetailersImportFile.name }} </span>
          <span
            class="catalog-label size"
          >Size: {{ (formatNumber(directRetailersImportFile.size / 1024), 2) }} KB</span>
          <div
            v-if="directRetailersImportFile"
            class="delete-file d-flex align-items-center justify-content-center"
            @click="directRetailersImportFile = null"
          >
            <feather-icon
              icon="TrashIcon"
              size="24"
              fill="white"
              color="white"
            />
          </div>
        </div>
        <b-form-file
          id="uploadCatalog"
          v-model="directRetailersImportFile"
          name="uploadCatalog"
          accept=".xlsx"
          :hidden="true"
          plain
        />
      </div>
      <div>
        <div class="text-center mt-1">
          <b-button
            type="reset"
            class="mt-2 mr-2 px-sm-3 font-weight-bolder"
            variant="outline-info"
            @click="closeImportDirectRetailersModal"
          >
            Cancel
          </b-button>
          <b-button
            type="submit"
            variant="info"
            class="mt-2 px-sm-3 font-weight-bolder"
            :disabled="isUploadingDirectRetailers || (!directRetailersImportFileLink && !directRetailersImportFile)"
            @click="uploadDirectRetailers(false)"
          >
            {{ isUploadingDirectRetailers ? "Saving": "Save" }}
          </b-button>
        </div>
      </div>
    </b-modal>

    <retailer-teammates-modal
      ref="retailerTeammatesModal"
      :retailer-id="selectedRetailerIdForTeammates"
      :retailer-name="selectedRetailerName"
      @open-invite="openInviteTeammateModal"
    />
    <invite-teammate-modal
      :retailer-id="selectedRetailerIdForTeammates"
      @invited="onTeammateInvited"
    />
  </div>
</template>

<script>
import FacebookIcon from '@/@core/assets/svg-components/FacebookIcon.vue'
import ImportIcon from '@/@core/assets/svg-components/ImportIcon.vue'
import InstagramIcon from '@/@core/assets/svg-components/InstagramIcon.vue'
import LinkedInIcon from '@/@core/assets/svg-components/LinkedInIcon.vue'
import PencilIcon2 from '@/@core/assets/svg-components/PencilIcon2.vue'
import SendIcon from '@/@core/assets/svg-components/SendIcon.vue'
import TwitterIcon from '@/@core/assets/svg-components/TwitterIcon.vue'
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue'
import { apiToastSuccess, apiToastWarning } from '@/@core/utils/toast'
import analytics from '@/@core/utils/analytics'
import constants from '@/constants'
import { UPLOAD_DOCUMENTS } from '@/store/modules/common.module'
import {
IMPORT_DIRECT_USERS,
VALIDATE_RETAILER_IMPORT_FILE,
UPDATE_CONNECTION_REQUEST,
} from '@/store/modules/connections.module'
import { constants as c } from '@kingpin-global/kingpin-utils-frontend'

import {
BButton,
BCard,
BCardText,
BCol,
BFormFile,
BFormInput,
BImg,
BLink,
BModal,
BPagination,
BRow,
BSpinner,
BTable,
VBModal,
VBTooltip,
} from 'bootstrap-vue'
import { useConnections } from '@/composables/useConnections'
import UserRoleMixinVue from '../UserRoleMixin.vue'
import AddUserModal from './AddUserModal.vue'
import ConnectionRequest from './ConnectionRequest.vue'
import EditUserModal from './EditUserModal.vue'
import AddNickName from './AddNickName.vue'
import RepsListDropdown from './RepsListDropdown.vue'
import RetailerTeammatesModal from './RetailerTeammatesModal.vue'
import InviteTeammateModal from './InviteTeammateModal.vue'

const { FILE_TYPES } = c

export default {
  name: 'ConnectionRequestList',
  components: {
    BTable,
    BCard,
    FeatherIcon,
    BModal,
    BRow,
    BCol,
    BPagination,
    BSpinner,
    BButton,
    ConnectionRequest,
    AddUserModal,
    BLink,
    InstagramIcon,
    FacebookIcon,
    LinkedInIcon,
    TwitterIcon,
    SendIcon,
    BCardText,
    PencilIcon2,
    EditUserModal,
    BFormInput,
    ImportIcon,
    BImg,
    BFormFile,
    AddNickName,
    RepsListDropdown,
    RetailerTeammatesModal,
    InviteTeammateModal,
  },
  directives: {
    'b-modal': VBModal,
    'b-tooltip': VBTooltip,
  },
  mixins: [UserRoleMixinVue],
  setup() {
    const {
 isBrand, isRetailer, isEntityAdmin, isSalesManager, ...conn
} = useConnections()
    conn.initConnections()
    return {
      ...conn,
      xlsxIcon: require('@/assets/images/icons/xlsxIcon.svg'),
    }
  },
  methods: {
    closeModal() {
      this.$refs.connnectionRequest.hide()
    },
    openConnectionRequest(data) {
      this.setConnectionRequestTarget(this.tableItems[data.index])
      this.$refs.connnectionRequest.show()
    },
    onUpdateRequest(status, message, requestId) {
      const toastMessage = `Request ${status}`
      const payload = {
        status,
        message,
      }
      this.$store
        .dispatch(UPDATE_CONNECTION_REQUEST, { requestId, payload })
        .then(() => {
          apiToastSuccess(toastMessage)
          this.getData()
        })
        .catch(() => {})
    },
    closeImportDirectRetailersModal() {
      this.resetImportState()
      this.$bvModal.hide('import_direct_retailers')
    },
    async showConfirmImportModal() {
      const confirmed = await this.$bvModal.msgBoxConfirm(
        'Changing the transaction currency will remove all linked price books. Previous order values will remain unchanged. Are you sure you want to continue?',
        {
          title: 'Confirm Currency Change',
          okVariant: 'danger',
          cancelVariant: 'outline-secondary',
          okTitle: 'Yes, Change Currency',
          cancelTitle: 'Cancel',
          centered: true,
        },
      )
      if (confirmed) {
        await this.uploadDirectRetailers(true)
      }
    },
    async uploadDirectRetailers(isConfirmed = false) {
    try {
      this.isUploadingDirectRetailers = true
      this._ensureFileSelected()
      await this._ensureFileUploaded()
      const payload = { file: this.importFileUrl }
      if (!isConfirmed && await this._hasCurrencyChange(payload)) {
        await this.showConfirmImportModal()
        return
      }
      await this._importDirectUsers(payload)
      this.closeImportDirectRetailersModal()
      this.getData()
    } catch (err) {
      apiToastWarning(err || 'An error occurred while importing direct retailers')
    } finally {
      this.isUploadingDirectRetailers = false
      this.importFileUrl = null
    }
  },

  _ensureFileSelected() {
    if (!this.directRetailersImportFile) {
      throw new Error('Please select a file')
    }
  },

  async _ensureFileUploaded() {
    if (!this.importFileUrl) {
      this.importFileUrl = await this.$store.dispatch(
        UPLOAD_DOCUMENTS,
        { file: this.directRetailersImportFile, fileType: FILE_TYPES.DIRECT_RETAILERS },
      )
    }
  },

  async _hasCurrencyChange(payload) {
    const response = await this.$store.dispatch(VALIDATE_RETAILER_IMPORT_FILE, { payload })
    return response?.data?.data?.hasCurrencyChange
  },

  async _importDirectUsers(payload) {
    const params = { shouldUpdateExistingUser: true }
    const result = await this.$store.dispatch(IMPORT_DIRECT_USERS, { payload, params })
    apiToastSuccess(result.data.message)
  },
    openTeammatesModal(item) {
      this.setTeammatesTarget(item)
      analytics.track(constants.TRACKS.ACTIONS.RETAILER_TEAMMATES.BRAND_CLICKS_VIEW_TEAMMATES, {
        retailerId: item.retailerId,
        retailerName: item.entityName,
      })
      this.$bvModal.show('retailer_teammates_modal')
    },
    openInviteTeammateModal() {
      this.$bvModal.show('invite_teammate_modal')
    },
    onTeammateInvited() {
      this.$refs.retailerTeammatesModal.refreshTeammates()
    },
  },
}
</script>

<style lang="scss">
@import '~@core/scss/base/pages/page-misc.scss';
@import '~@core/scss/base/pages/app-ecommerce.scss';

.my-retailer-banner-1 {
  background-image: url(./my-retailer-banner1.png);
}
.my-retailer-banner-2 {
  background-image: url(./my-retailer-banner2.png);
}

.my-retailer-banner {
  background-repeat: no-repeat;
  background-position-y: center;
  background-size: cover;
  min-height: 160px;
  border: 1px solid $dashboard-empty-icon-color;
  border-radius: 6px;

  .banner-content {
    margin: 24px;
    .title {
      font-weight: 700;
      font-size: 24px;
      line-height: 32px;
    }

    .sub-title {
      margin-top: 5px;
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
    }
  }
}
.payment-term-block {
  min-width: 200px;
}
.wallet-search-icon {
  position: absolute;
  right: 25px;
  top: 10px;
}

</style>
